import 'bootstrap/dist/css/bootstrap.css';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import CookieConsent from "react-cookie-consent";
import ZaccoVideo from "../assets/HomePageVideo.mp4";
import ZaccoDo from "../assets/ZaccoDo.png";

export interface IHomeProps {
}
export interface IHomeState {
    loading: boolean;
    isValidData: boolean;
}
const overflowcontent = mergeStyles({
    position: "fixed",
    top: "30%",
    transform: "translate(-50%)",
    color: "#fff",
    width: "100%",
    textAlign: "center",
    left: "50%",
    height: "100%"
});
const banner = mergeStyles({ width: "100vw", overflow: "hidden", position: "fixed", height: "100vh", backgroundSize: "cover", objectFit: "cover" });
const img = mergeStyles({ maxWidth: "60vw", maxHeight: "60vh", margin: "0 auto" });
const video = mergeStyles({ objectFit: "cover", width: "100vw", height: "100vh", position: "fixed" });
export default class Home extends React.Component<IHomeProps, IHomeState>{
    constructor(props: IHomeProps, state: IHomeState) {
        super(props);
        this.state = {
            loading: false,
            isValidData: true
        }
    }
    public render(): React.ReactElement<IHomeProps> {
        return (
            <div className={banner}>
                <video id="myVideobanner" className={video} autoPlay loop muted playsInline>
                    <source src={ZaccoVideo} type="video/mp4" />
                </video>
                <div className={overflowcontent} >
                    <h2>When the <br />
                        world changes, <br />
                        so do we</h2>
                    <img src={ZaccoDo} alt={"ZaccoDo"} className={img} />
                </div>
                <CookieConsent
                    location="bottom"
                    buttonText="GOT IT"
                    cookieName="cookies"
                    style={{ background: "#2B373B" }}
                    buttonStyle={{ color: "#005269", fontSize: "13px" }}
                    expires={365}
                >
                    <h6>
                        <strong>We use cookies for a better user experience. By continuing to browse the site you accept our use of cookies. </strong> <a href="https://www.zacco.com/web-privacy-policy/" rel="noopener noreferrer" target="_blank">Read more here.</a>
                    </h6>
                </CookieConsent>
            </div>
        );
    }
}